import type { CSSProperties } from 'react';
import type { ChatAiResult } from './chat-ai.js';

type Interpretation = Extract<ChatAiResult, { task: 'interpret_context' }>;

export function ChatInterpretation({ result }: { result: Interpretation }) {
  const report = result.report;
  const score = result.interestPercent;
  return (
    <section className="ai-interpret" aria-label="Разбор чата">
      <header className="ai-interpret__rating">
        <div
          className="ai-interpret__score"
          style={{ '--interest': `${score ?? 0}%` } as CSSProperties}
          role={score === null ? 'img' : 'meter'}
          aria-label={
            score === null
              ? 'Недостаточно данных для оценки интереса'
              : 'Заинтересованность собеседника'
          }
          aria-valuemin={score === null ? undefined : 0}
          aria-valuemax={score === null ? undefined : 100}
          aria-valuenow={score ?? undefined}
          aria-valuetext={score === null ? undefined : `${score} из 100`}
        >
          <span>
            <strong>{score ?? '—'}</strong>
            <small>{score === null ? 'мало данных' : 'из 100'}</small>
          </span>
        </div>
        <span>💗 Заинтересованность собеседника:</span>
        {result.confidence === 'low' && score !== null ? (
          <small>Пока мало данных — оценка приблизительная</small>
        ) : null}
      </header>
      <div>
        <strong>💡 Краткий вывод:</strong>
        <p>{result.analysis}</p>
      </div>
      <div>
        <strong>💚 Что собеседнику интересно:</strong>
        <p>{report?.likes.length ? report.likes.join(' ') : 'Предпочтения пока не ясны.'}</p>
      </div>
      <div>
        <strong>🚫 Чего лучше избегать:</strong>
        <p>
          {report?.dialogue.length
            ? report.dialogue.join(' ')
            : 'Пока недостаточно реакций для персонального совета.'}
        </p>
      </div>
      <div>
        <strong>💬 Попробуй поговорить о:</strong>
        {report?.topics.length ? (
          <ul className="ai-interpret__topics">
            {report.topics.slice(0, 3).map((topic, index) => (
              <li key={index}>
                {/\p{Extended_Pictographic}/u.test(topic.topic)
                  ? ''
                  : `${['💬', '✨', '🌿'][index]} `}
                {topic.topic}
              </li>
            ))}
          </ul>
        ) : (
          <p className="hint">Нет подтверждённых тем для продолжения.</p>
        )}
      </div>
      <div>
        <strong>🎯 Что делать сейчас:</strong>
        <p>{report?.nextStep ?? 'Сначала дождись новых реплик, чтобы лучше понять собеседника.'}</p>
      </div>
    </section>
  );
}
